import React from 'react';
import ReactDOM from 'react-dom/client';
import MenuApp from './MenuApp.jsx';
import './index.css';
import './fonts.css';
import './scenes.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MenuApp />
  </React.StrictMode>,
);

// Service worker: registered three seconds after load, so precaching the
// build (~1 MB with three.js and the fonts) never competes with the photos
// a guest is scrolling into. The worker itself is generated by vite-plugin-pwa
// (autoUpdate: skipWaiting + clientsClaim), so a reload after a deploy is fresh.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  const register = () => window.setTimeout(() => navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {}), 3000);
  if (document.readyState === 'complete') register(); else window.addEventListener('load', register, { once: true });
}
